<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de material">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/cadastro/relatorio-material/List'

export default {
    components: {List},
}
</script>